export const environment = {
	production: true,
	baseUrl: 'https://d1zbpjaw8vpot1.cloudfront.net',
	assetUrl: 'https://d3bos3p2qovbz5.cloudfront.net',
	loginUrl: 'https://www.yashtech.ai/',
	postLogOutUrl: 'https://www.yashtech.ai/',
	getAllianceList: '/api/alliances-and-partner?populate=*',
	getAllUseCases: '/api/ai-usecases?populate=*&pagination[page]=${pageno}&pagination[pageSize]=20',
	getAppGalleryDetail: '/api/real-world-application',
	getAppGalleryFilterList: '/api/application-use-categories',
	getAppGalleryList: '/api/ai-usecases?populate=*&pagination[pageSize]=8',
	getContactUsData:
		'/api/use-case-templates/${id}?populate[0]=UseCaseTemplates.FAQItem&populate[1]=UseCaseTemplates.app_categories&populate[2]=UseCaseTemplates.content',
	getIndustriesList: '/api/industries-we-serve?populate=IndustriesTile.industryImage',
	getIntroList: '/api/home-page-gen-ai-intro',
	getLandingPageData: '/api/landing-catagories?populate[0]=landing_page_tiles&populate[1]=landing_page_tiles.Tile_img',
	getLeapSectioDetail: '/api/home-get-in-touch?populate=*',
	getMenuList:
		'/api/main-menu?populate[0]=MainMenuItems&populate[1]=MainMenuItems.menu_sections&populate[2]=MainMenuItems.menu_sections.links.Tech_Img&populate[3]=MainMenuItems.menu_sections.links.ai_usecases&populate[4]=MainMenuItems.menu_sections.links.ai_usecases.use_case_template',
	getResources: '/api/ai-resources?populate=*',
	getResourcesDetailAtHome: '/api/home-resource?populate=*',
	getResourcesListAtHome: '/api/ai-resources?populate=*&pagination[pageSize]=3',
	getServicesList: '/api/mastaring-ai-tech?populate=Images&populate[1]=LabelWithImage.image',
	getSliderList: '/api/home-slider?populate[0]=slide.bgImage',
	getAIJourneyCTA: '/api/ai-journey',
	submitContactUsData: '/api/book-a-demos',
	getResourceDetailsView: '/api/resource-details/${pageId}?populate=*',
	chatBotService: 'https://yqn6tqkobxs3n5vvuvaz5wik2y0vidna.lambda-url.ap-south-1.on.aws/',
};
